"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./HBetTrendUtils";

export default function HBetCorrectScoresSection({ title, correctScoresFull }) {
  const { home = [], draw = [], away = [] } = correctScoresFull || {};
  const allScores = [...home, ...draw, ...away];

  if (allScores.length === 0) return null;

  return (
    <div className="hbet-ods-detail-item kbv-hbet-odt-card ods-100">
      <div className="hbet-odstb-title kbv-hbet-odt-txt">
        <span>{title}</span>
        <span></span>
      </div>
      <div className="hbet-odstb-odds-list hbet-scores-grid">
        {home.map((item, i) => (
          <div key={`h${i}`}>
            <div className="hbet-title-odds">{item.label}</div>
            <div className="score-values">
              <div className={`odds kbv-hbet-odt-odds ods-100 ods-white ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div className={`odds ods-100 ods-white ${trendClass(item.trend2)}`}>
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        {draw.map((item, i) => (
          <div key={`d${i}`}>
            <div className="hbet-title-odds">{item.label}</div>
            <div className="score-values">
              <div className={`odds kbv-hbet-odt-odds ods-100 ods-white ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
            </div>
          </div>
        ))}
        {away.map((item, i) => (
          <div key={`a${i}`}>
            <div className="hbet-title-odds">{item.label}</div>
            <div className="score-values">
              <div className={`odds kbv-hbet-odt-odds ods-100 ods-white ${trendClass(item.trend)}`}>
                {displayValue(item.value)}
              </div>
              {item.value2 !== undefined && (
                <div className={`odds ods-100 ods-white ${trendClass(item.trend2)}`}>
                  {displayValue(item.value2)}
                </div>
              )}
            </div>
          </div>
        ))}
        <div>
          <div className="hbet-title-odds">AOS</div>
          <div className="score-values">
            <div className="odds kbv-hbet-odt-odds ods-100 ods-white">-</div>
          </div>
        </div>
      </div>
    </div>
  );
}
